import { CircleArrowLeft } from "lucide-react";
import { AuditLogsTable } from "./audit-logs-table";
import { Link } from "@tanstack/react-router";


export function AuditLogsPage() {
  return (
    <div className='min-h-screen bg-white p-10'>
      <Link to='/dashboard' className='flex w-max items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Audit Logs</h2>
      </Link>
      <div className='mt-4 border-t pt-8'>
        <AuditLogsTable />
      </div>
    </div>
  );
}
